import { Link } from 'react-router-dom';
import { colors, lavenderButtonStyle } from '../lib/theme';

const STEPS = [
  {
    title: 'Meal',
    color: colors.blue,
    textColor: colors.blueText,
    body: 'Your daily view. Each meal slot suggests a few dishes — tap Choose to log one, Show me something else to swap it for another suggestion, or Ate out / delivery to skip logging a dish entirely.',
  },
  {
    title: 'Menu',
    color: colors.mint,
    textColor: colors.mintText,
    body: 'Your dish library. Add a dish with its calories, protein, and which meal slots it fits, or edit/archive existing ones. Dishes here are what Meal suggests from.',
  },
  {
    title: 'Products',
    color: colors.peach,
    textColor: colors.peachText,
    body: 'Reusable ingredients with calories per 100g (and optional protein/fat/carbs/category). Tag up to 10 products onto a dish in the Menu editor so you can see at a glance what a dish actually contains.',
  },
];

export default function Onboarding() {
  return (
    <div>
      <h2>How to use DishSensei</h2>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', margin: '1.5rem 0', maxWidth: 480 }}>
        {STEPS.map((step, i) => (
          <div
            key={step.title}
            style={{
              background: step.color,
              color: step.textColor,
              borderRadius: 14,
              padding: '0.9rem 1.1rem',
            }}
          >
            <div style={{ fontWeight: 700 }}>
              {i + 1}. {step.title}
            </div>
            <div style={{ fontSize: '0.9rem', opacity: 0.85, marginTop: '0.25rem' }}>{step.body}</div>
          </div>
        ))}
      </div>

      <div style={{ maxWidth: 480 }}>
        <div style={{ fontWeight: 700, marginBottom: '0.25rem' }}>Want more?</div>
        <p style={{ fontSize: '0.9rem', opacity: 0.75 }}>
          A shopping list built from your logged meals and a daily kcal limit tracker are available on PRO.
        </p>
        <Link to="/upgrade">
          <button style={lavenderButtonStyle}>See PRO features</button>
        </Link>
      </div>
    </div>
  );
}
